export default {"src":"/frontend-static/_next/static/media/carbon-neutral.b8753599.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};